import React, { useEffect, useState } from "react";
import {useParams } from "react-router-dom";
import { onlyNumber, onlyNumberdesimal, onlyLetters } from "../helpers/formats";
import { addExpenseData, updateExpenses } from "../services/expenses";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BeatLoader from "react-spinners/BeatLoader";
// import CommonLabel from "./common/commonLable";
import CustomField from "./common/customField";
import { initialValuesForExpense } from "./common/utlity/intialValues";
import {
  optionsForExpenseCategory,
  optionsForExpenseTax,
  optionsForModeOfPayment,
  paymentStatusOptions,
} from "./common/utlity/options";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import TourGuide from "./common/TourGuide";
import { ExpenseSteps } from "../lib/constants/TourSteps";
import { AWS_URL } from "../services/http.service";
import { useNavigate } from "react-router-dom";
import { FiCreditCard,FiArrowLeft, FiEdit3 } from "react-icons/fi";

const AddExpenses = ({
  close,
  updateExpense,
  addExpense,
  item,
  businessUuid,
  initialValues,
}) => {
  const [updatedAmount, setUpdatedAmount] = useState(0);
  const [itemphoto, setItemphoto] = useState(null);
  const [expenseIsLoading, setExpenseIsLoading] = useState(false);
  const expenses = useSelector((state) => state?.expenses.expenses);
  const { t } = useTranslation();
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  const [runTour, setRunTour] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const waitForElements = () => {
      const allElementsExist = document.querySelector(".expense-taxable-tour");
      //  document.querySelector(".transaction-status-tour");

      if (expenses?.length === 0 && allElementsExist) {
        setRunTour(true);
      } else {
        setTimeout(waitForElements, 300);
      }
    };

    waitForElements();
  }, [expenses]);
  const handleChangeforFile = (e) => {
    const selectedFile = e.target.files[0];
    setItemphoto(selectedFile);
  };
  const signInSchema = Yup.object().shape({
    expenseName: Yup.string().required(
      <span className='text-xs dark:text-red-500'>
        Expense name is required
      </span>
    ),

    amount: Yup.number().required(
      <span className='text-xs dark:text-red-500'>Amount is required</span>
    ),
  });

  const onSubmit = async (values, { resetForm }) => {
    if (!finalBusinessUuid) {
      toast.error("Business UUID is missing");
      // Using translation
      return;
    }

    try {
      // Prepare FormData
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        formData.append(key, value);
      });

      if (itemphoto) {
        formData.append("avatar", itemphoto);
      }

      if (updatedAmount > 0) {
        formData.set("totalAmount", updatedAmount);
      }

      setExpenseIsLoading(true);

      if (item) {
        // Update existing expense
        const { expenseID } = item;
        const result = await updateExpenses(
          finalBusinessUuid,
          expenseID,
          formData
        );

        if (result.data) {
          updateExpense(result.data);
          toast.success(t("Expense Updated Successfully"));
          navigate(-1);
          close(true); // Pass true to indicate success and trigger refresh
        } else {
          throw new Error("Update failed");
        }
      } else {
        // Create new expense
        const result = await addExpenseData(finalBusinessUuid, formData);

        if (result.data) {
          addExpense(result.data);
          toast.success(t("Expense Added Successfully"));
          resetForm();
          close(); // Close modal after success
          navigate(-1)
        } else {
          throw new Error("Creation failed");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(t("MESSAGE.SOMETHING_WENT_WRONG"));
    } finally {
      setExpenseIsLoading(false);
    }
  };

  return (
    <>
      <TourGuide steps={ExpenseSteps} runTour={runTour} />
      <Formik
        // enableReinitialize={true}
        initialValues={{
          ...initialValuesForExpense(item ? item : null),
          ...initialValues,
        }}
        validationSchema={signInSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          const {
            errors,
            values,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
          } = formik;
          const calculateTotalAmount = () => {
            const baseAmount = parseFloat(values.amount) || 0;
            const igst = parseFloat(values.igst) || 0;
            const cgst = parseFloat(values.cgst) || 0;
            const sgst = parseFloat(values.sgst) || 0;
            const cess = parseFloat(values.cess) || 0;
            const totalGSTPercent = igst + cgst + sgst + cess;
            const totalAmount =
              baseAmount + (baseAmount * totalGSTPercent) / 100;
            setUpdatedAmount(totalAmount);
            return totalAmount.toFixed(2);
          };
          const handleChangeForTaxable = (e) => {
            handleChange(e);
            if (e.target.value === "no_tax") {
              setFieldValue("igst", "");
              setFieldValue("cgst", "");
              setFieldValue("sgst", "");
              setFieldValue("cess", "");
            }
          };
          return (
            <Form>
              <div className="bg-blue-50 dark:bg-[#020617] dark:text-white">
                <div className='grid gap-4 grid-cols-1 '>
                  <div className='p-2 bg-white dark:bg-slate-900 className="h-[calc(100vh-64px)]" dark:text-white dark:text-white'>
                    <div className=" mt-1 p-4 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gradient-to-br dark:from-slate-900 dark:via-indigo-950 dark:to-slate-800 shadow-[0_0_15px_rgba(0,0,0,0.08)] dark:shadow-[0_0_20px_rgba(0,0,0,0.4)]">
                      <div className="mb-5 flex items-center justify-between">
  <div className="flex items-center gap-4">
    <button
                                                                type="button"
                                                                onClick={() => navigate(-1)}
                                                                className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
                                                              >
                                                                <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
                                                              </button>
    <div className="w-14 h-14 rounded-xl bg-red-100 text-red-600 flex items-center justify-center shadow">
      {item ? <FiEdit3 size={28} /> : <FiCreditCard size={28} />}
    </div>

    <div>
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
        {item ? t('LANGUAGE.UPDATE_EXPENSE') : t('FORM.ADD_EXPENSE')}
      </h1>

      <p className="text-sm text-gray-500 dark:text-gray-400">
        {item
          ? t("EXTRA.MODIFY_THE_EXPENSE")
          : t("EXTRA.ENTER_THE_EXPENSE")}
      </p>
    </div>
  </div>
</div>
                      <div className="grid grid-cols-4 gap-4 w-full mb-4 ">
                      {/* Expense Name */}
                      <div className='p-1'>
                        <CustomField
                          type='text'
                          name='expenseName'
                          label={t("FORM.EXPENSE_NAME")}
                          placeholder='Expense Name *'
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          value={values.expenseName}
                          error={errors.expenseName}
                          touched={touched.expenseName}
                        />
                      </div>

                      {/* Expense Category and Other Category (same width) */}
                      <div className='p-1'>
                        <div className='flex gap-2'>
                          {/* Dropdown */}
                          <div className='w-full'>
                            <CustomField
                              type='select'
                              name='expenseCategory'
                              label={t("FORM.EXPENSE_CATEGORY")}
                              placeholder='Select Category'
                              options={optionsForExpenseCategory}
                              setFieldValue={(name, value) => {
                                setFieldValue(name, value);
                                if (value !== "other") {
                                  setFieldValue("expenseOtherCategory", "");
                                }
                              }}
                              handleChange={(e) => {
                                handleChange(e);
                                if (e.target.value !== "other") {
                                  setFieldValue("expenseOtherCategory", "");
                                }
                              }}
                              value={values.expenseCategory}
                              error={errors.expenseCategory}
                              touched={touched.expenseCategory}
                            />
                          </div>

                          {/* Input for "Other" */}
                          {values.expenseCategory === "other" && (
                            <div className='w-full'>
                              <TextField
                                type='text'
                                name='expenseOtherCategory'
                                label='Expense Category *'
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue(
                                    "expenseOtherCategory",
                                    e.target.value
                                  );
                                }}
                                onBlur={handleBlur}
                                value={values.expenseOtherCategory}
                                error={values.expenseOtherCategory === ""}
                                touched={touched.expenseOtherCategory}
                                helperText={
                                  values.expenseOtherCategory === "" ? (
                                    <span className='text-gray-600 dark:text-white'>
                                      Other Category Is Required
                                    </span>
                                  ) : (
                                    ""
                                  )
                                }
                                size='small'
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: 30,
                                  },
                                }}
                                InputProps={{
                                  className:
                                    "dark:text-white dark:bg-[#1f2937] dark:border-white focus:border-blue-600",
                                }}
                                InputLabelProps={{
                                  className: "dark:text-white",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Status */}
                      <div className='p-1'>
                        <CustomField
                          type='select'
                          name='status'
                          label={t("FORM.STATUS")}
                          placeholder='Select Status'
                          options={paymentStatusOptions}
                          setFieldValue={setFieldValue}
                          handleChange={handleChange}
                          value={values.status}
                          error={errors.status}
                          touched={touched.status}
                        />
                      </div>

                      {/* Approved Date Field - Conditionally Rendered */}
                      {values.status === "approved_&_paid" && (
                          <div className='p-1'>
                            <CustomField
                              type='date'
                              name='approvedDate'
                              label={t("Approved date")}
                              placeholder='Approved Date *'
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.approvedDate}
                              error={errors.approvedDate}
                              touched={touched.approvedDate}
                              required
                            />
                          </div>
                      )}
                    </div>
                    <div className="grid grid-cols-4 gap-4 w-full mb-4">
                      {values.expenseCategory === "salary" && (
                        <>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='employeeName'
                              label={t("FORM.EMPLOYEE_NAME")}
                              placeholder='Employee Name'
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.employeeName}
                              error={errors.employeeName}
                              touched={touched.employeeName}
                            />
                          </div>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='employeeMobile'
                              label={t("FORM.EMPLOYEE_MOBILE")}
                              placeholder='Employee Mobile No'
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.employeeMobile}
                              maxLength={10}
                              onKeyPress={onlyNumber}
                            />
                          </div>

                          <div className='p-1'>
                            <CustomField
                              type='date'
                              name='salaryDateFrom'
                              label={t("SIDER.SALARY_DATE_FROM")}
                              placeholder='Salary Date From'
                              handleChange={handleChange}
                              value={values.salaryDateFrom}
                            />
                          </div>
                          <div className="p-1">
                            <CustomField
                              type='date'
                              name='salaryDateTo'
                              label={t("SIDER.SALARY_DATE_TO")}
                              placeholder='Salary Date To'
                              handleChange={handleChange}
                              value={values.salaryDateTo}
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="grid grid-cols-4 gap-4 w-full mb-4">
                      <div className='p-1'>
                        <CustomField
                          type='select'
                          name='modeOfPayment'
                          placeholder='Payment mode'
                          label={t("CASHBOOK.MODE_OF_PAYMENT")}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          options={optionsForModeOfPayment}
                          value={values.modeOfPayment}
                        />
                      </div>
                      <div className='p-1'>
                        <CustomField
                          type='text'
                          name='amount'
                          label={t("FORM.AMOUNT*")}
                          placeholder='Amount'
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          onKeyPress={onlyNumberdesimal}
                          value={values.amount}
                          error={errors.amount}
                          touched={touched.amount}
                        />
                      </div>
                      <div className='p-1'>
                        <CustomField
                          type='date'
                          name='date'
                          label={t("FORM.CREATOR_DATE")}
                          placeholder='Create Date'
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          value={values.date}
                          error={errors.date}
                          touched={touched.date}
                        />
                      </div>
                      <div className='p-1'>
                        <CustomField
                          type='time'
                          name='expenseTime'
                          placeholder='Create Time'
                          label={t("FORM.CREATOR_TIME")}
                          handleChange={handleChange}
                          timeIntervals={5}
                          value={values.expenseTime}
                          setFieldValue={setFieldValue}
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-4 gap-4 w-full mb-4">
                      
                      {values.expenseCategory !== "salary" && (
                        <div className='p-1'>
                          <CustomField
                            type='text'
                            name='paidTo'
                            label={t("FORM.PAYMENT_TO")}
                            placeholder='Paid To'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.paidTo}
                            error={errors.paidTo}
                            touched={touched.paidTo}
                          />
                        </div>
                      )}
                      <div className='p-1 '>
                        <CustomField
                          type='text'
                          name='creatorName'
                          label={t("FORM.CREATOR_NAME")}
                          placeholder='Creater Name'
                          handleChange={handleChange}
                          value={values.creatorName}
                          onKeyPress={onlyLetters}
                        />
                      </div>
                      <div className='p-1'>
                        <CustomField
                          type='text'
                          name='creatorRole'
                          label={t("FORM.CREATOR_ROLE")}
                          placeholder='Creator Role'
                          handleChange={handleChange}
                          value={values.creatorRole}
                        />
                      </div>
                      <div className='p-1 expense-taxable-tour'>
                        <CustomField
                          type='select'
                          name='taxable_expense'
                          label={t("FORM.TAXABLE")}
                          placeholder='Taxable'
                          options={optionsForExpenseTax}
                          setFieldValue={setFieldValue}
                          handleChange={handleChangeForTaxable}
                          value={values.taxable_expense}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-5 gap-4 w-full mb-4">
                      {values.taxable_expense === "taxable" && (
                        <>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='igst'
                              label={t("TAX.IGST")}
                              placeholder='IGST'
                              handleChange={
                                values.sgst_utgst || values.cgst
                                  ? undefined
                                  : handleChange
                              }
                              handleBlur={handleBlur}
                              value={values.igst}
                              onKeyPress={onlyNumber}
                              helperText={
                                <span className='text-gray-600 dark:text-red-500'>
                                  {values.sgst_utgst || values.cgst
                                    ? "Cannot calculate with SGST or CGST"
                                    : ""}
                                </span>
                              }
                              // disabled={values.cgst || values.sgst_utgst}
                              disabled={
                                Number(values.cgst) > 0 ||
                                Number(values.sgst_utgst) > 0
                              }
                            />
                          </div>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='cgst'
                              label={t("TAX.CGST")}
                              placeholder='CGST'
                              handleChange={
                                values.igst ? undefined : handleChange
                              }
                              handleBlur={handleBlur}
                              value={values.cgst}
                              onKeyPress={onlyNumber}
                              helperText={
                                values.igst ? (
                                  <span className='text-gray-600 dark:text-red-500'>
                                    Cannot calculate with IGST
                                  </span>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </div>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='sgst_utgst'
                              label={t("TAX.SGST")}
                              placeholder='SGST/UTGST'
                              handleChange={
                                values.igst ? undefined : handleChange
                              }
                              handleBlur={handleBlur}
                              value={values.sgst_utgst}
                              onKeyPress={onlyNumber}
                              helperText={
                                values.igst ? (
                                  <span className='text-gray-600 dark:text-red-500'>
                                    Cannot calculate with IGST
                                  </span>
                                ) : (
                                  ""
                                )
                              }
                              disabled={values.igst}
                            />
                          </div>

                          <div className=' p-1'>
                            <CustomField
                              type='text'
                              name='cess'
                              label={t("TAX.CESS")}
                              placeholder='CESS(%)'
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={values.cess}
                              onKeyPress={onlyNumber}
                            />
                          </div>
                          <div className='p-1'>
                            <CustomField
                              type='text'
                              name='totalAmount'
                              label={t("COMMON.TOTAL_AMOUNT")}
                              placeholder='Total Amount'
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              value={calculateTotalAmount()}
                              onKeyPress={onlyNumber}
                            />
                          </div>
                        </>
                      )}
                    </div>
                      <div className='col-span-2 mb-5'>
                        {item && item.document ? (
                          <div className='w-full flex'>
                            <div className='w-1/3 mr-1'>
                              <div className='items-center '>
                                <img
                                  src={AWS_URL+item.document}
                                  alt='item'
                                  className='h-20'
                                />
                              </div>
                            </div>
                            <div className='w-2/3'>
                              <CustomField
                                type='file'
                                name='document'
                                placeholder='Change Document'
                                handleChange={handleChangeforFile}
                                value={
                                  values.itemphoto ? values.itemphoto.name : ""
                                }
                                uploadFiletext={
                                  itemphoto
                                    ? itemphoto?.name
                                    : "Change Document"
                                }
                                extraClass='p-7'
                              />
                            </div>
                          </div>
                        ) : (
                          <CustomField
                            type='file'
                            name='document'
                            placeholder='Upload Document'
                            handleChange={handleChangeforFile}
                            value={
                              values.itemphoto ? values.itemphoto.name : ""
                            }
                            uploadFiletext={
                              itemphoto ? itemphoto?.name : "Upload Document"
                            }
                            extraClass='p-7'
                          />
                        )}
                      </div>
                    <div className='flex justify-end'>
                      {item ? (
                        <button
                          type='submit'
                          className="w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white mt-4 font-bold rounded flex items-center justify-center"
                          disabled={expenseIsLoading}
                        >
                          {expenseIsLoading ? (
                            <BeatLoader
                              size={8}
                              color='#ffffff'
                              loading={expenseIsLoading}
                            />
                          ) : (
                            t("FORM.UPDATE_EXPENSE")
                          )}
                        </button>
                      ) : (
                        <button
                          type='submit'
                          className="w-1/2 py-2 px-2 bg-blue-600 hover:bg-blue-700 text-white mt-4 font-bold rounded flex items-center justify-center"
                          disabled={expenseIsLoading}
                        >
                          {expenseIsLoading ? (
                            <BeatLoader
                              size={8}
                              color='#ffffff'
                              loading={expenseIsLoading}
                            />
                          ) : (
                            t("FORM.ADD_EXPENSE")
                          )}
                        </button>
                      )}
                    </div>
                    </div>

                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
export default AddExpenses;
